import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { apiGet } from "@/lib/api";
import { queryKeyOf } from "@/lib/queries";
import type { PerformanceData, RangeDays } from "@/lib/types";

/**
 * `GET /api/partner/performance?days=` under the same key as
 * `useGet(["performance", days], …)`. Switching the range keeps the last
 * range on screen until the new one lands, so the page does not flash a
 * skeleton on every click.
 */
export function usePerformance(days: RangeDays) {
  return useQuery({
    queryKey: queryKeyOf(["performance", days]),
    queryFn: () =>
      apiGet<PerformanceData>(`/api/partner/performance?days=${days}`),
    placeholderData: keepPreviousData,
  });
}
